import { useSelector } from 'react-redux';
import { getLastModified, getVehicleDetails } from '~/selectors';

const blobUrl = process.env.CVNA_APP_CDNBLOB_BASE_URL;

function useZoomedImage() {
  const { stockNumber } = useSelector(getVehicleDetails);
  const lastModified = useSelector(getLastModified);

  return `${blobUrl}/${stockNumber}/post-large/normalized/zoomcrop/${stockNumber}-edc-02.jpg?v=${lastModified}`;
}

export default useZoomedImage;
